export default __webpack_public_path__ + "static/montserrat-v15-latin-900-e66c7edc609e24bacbb705175669d814.woff2";